import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import * as S from "../css/StockAnalysis.styles";

const StockAnalysis = () => {
  const { symbol } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const stock = location.state?.stock;

  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchQuestions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/analysis/questions`)
        setQuestions(response.data);
        setFilteredQuestions(response.data);
      } catch (error) {
        console.error("Error fetching questions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, []);

  useEffect(() => {
    if (location.state?.fromChat) {
      handleBackFromChat();
    }
  }, [location.state]);

  const handleQuestionClick = (question) => {
    navigate(`chat`, {
      state: {
        stock,
        question,
      },
    });
  };

  const handleBackFromChat = () => {
    setSelectedQuestion(null);
    setMessages([]);
  };

  const handleSendQuestion = async () => {};

  const handleBackToQuestions = () => {
    setSelectedQuestion(null);
    setMessages([]);
  };

  if (!stock) {
    return <div>Loading...</div>;
  }

  return (
    <S.Container>
      <S.Header>
        <S.StockInfo>
          {/* <S.StockName>{stock.COMPNAME}</S.StockName> */}
        </S.StockInfo>
      </S.Header>
      <S.QuestionsGrid>
        {loading
          ? Array(6)
              .fill(0)
              .map((_, index) => <S.LoadingCard key={index} />)
          : filteredQuestions.map((question) => (
              <S.QuestionCard
                key={question.id}
                onClick={() => handleQuestionClick(question)}
              >
                {question.text}
              </S.QuestionCard>
            ))}
      </S.QuestionsGrid>
    </S.Container>
  );
};

export default StockAnalysis;
